import { EventEmitter } from "events"

import dispatcher from "../dispatcher"

class UserProfileStore extends EventEmitter {
    constructor() {
        super()
        this.setMaxListeners(0)
        this.editDialogOpen = false
    }

    getEditDialogOpen() {
        return this.editDialogOpen
    }

    setDevicesLimit(limit) {
        this.DevicesOffset = 0
        this.emit("change")
    }

    openUserProfileDialog() {
        this.editDialogOpen = true
        this.emit("opened")
        this.emit("change")
    }

    closeUserProfileDialog() {
        this.editDialogOpen = false
        this.emit("change")
    }

    handleActions(action) {
        switch (action.type) {
            case "GET_USER_PROFILE": {
                this.addUser(action.object)
                break
            }
            case "OPEN_USER_PROFILE": {
                this.openUserProfileDialog()
                break
            }
            case "CLOSE_USER_PROFILE": {
                this.closeUserProfileDialog()
                break
            }
        }
    }
}

const userProfileStore = new UserProfileStore()
dispatcher.register(userProfileStore.handleActions.bind(userProfileStore))

export default userProfileStore
